<template>
    <div
        class="form-group"
        :class="[
            {
                'show-currency-label': currency,
            },
            parentClass,
        ]"
    >
        <label class="form-group-label" :for="uniqueId">
            {{ label }}
        </label>
        <div class="input-group">
            <input
                v-bind="$attrs"
                @change="handleChange($event.target.value)"
                @focusin="focus = true"
                @focusout="focus = false"
                :value="inputValue"
                :placeholder="label"
                :required="required"
                :class="{ 'number-input': smaller }"
                :disabled="disabled"
                class="form-control"
                type="text"
            >
            <div v-if="currency" class="input-group-append">
                <span v-html="currency" class="input-group-text" />
            </div>
        </div>
        <input
            type="hidden"
            :name="name"
            :value="cents"
            :disabled="disabled"
        >
    </div>
</template>

<script>
    export default {
        name: 'UiInputMoney',
        inheritAttrs: false,
        props: {
            value: {
                type: [Number, String],
                default: '',
            },
            label: {
                type: String,
                default: 'Label',
            },
            name: {
                type: String,
                default: 'price',
            },
            required: {
                type: Boolean,
                default: false,
            },
            currency: {
                type: String,
                default: null,
            },
            smaller: {
                type: Boolean,
                default: false,
            },
            parentClass: {
                type: String,
                default: '',
            },
            precision: {
                type: Number,
                default: 2,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                inputValue: '',
                focus: false,
            };
        },
        computed: {
            cents() {
                if (this.inputValue === '' || isNaN(this.inputValue)) return '';

                const precision = Math.max(0, this.precision - 2);

                return +(Number(this.inputValue) * 100).toFixed(precision);
            },

            moveLabelToTop() {
                return this.focus || this.inputValue !== '';
            },

            uniqueId() {
                return this._uid;
            },
        },
        mounted() {
            this.updateInputValue();
        },
        methods: {
            updateInputValue() {
                this.inputValue = this.value || this.value === 0
                    ? +(Number(this.value) / 100).toFixed(this.precision)
                    : '';
            },

            handleChange(value) {
                let newValue = value.toString().trim().replace(',', '.');

                if (!isNaN(Number(newValue)) && newValue !== '') {
                    newValue = +Number(newValue).toFixed(this.precision);
                } else {
                    newValue = '';
                }

                this.inputValue = newValue;
                this.$emit('input', this.cents);
            },
        },
        watch: {
            value() {
                this.updateInputValue();
            },
        },
    };
</script>

<style lang="scss" scoped>
    .show-currency-label {
        .input-group {
            &-append {
                z-index: 3;
                margin-left: -3px;
            }

            &-text {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 40px;
                padding: 0;
            }
        }
    }

    .input-group {
        .custom-select {
            flex-grow: 0;
            width: 100px;
        }
    }
</style>
